/**
 * Analytics GraphQL Queries
 * Queries for Metabase resources and analytics data
 */

export const GET_METABASE_RESOURCES = `
  query getMetabaseDashboard {
    api_metabase_resource(where: {is_deleted: {_eq: false}}) {
      id
      name
      resource_type
      resource_id
    }
  }
`;
